import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ViewListIcon from '@mui/icons-material/ViewList';
import Stack from '@mui/material/Stack';

import BlankContent from '../common/BlankContent';

import CaseTableRow from './CaseTableRow';
import CaseCard from './CaseCard';
// import SessionListItem from './SessionListItem';
import CustomPagination from "../common/CustomPagination";

const columns = [
  {
    label: 'Status',
    key: 'status',
    align: 'left',
  },
  {
    label: 'Patient',
    key: 'patient',
    align: 'left',
  },
  {
    label: 'Name',
    key: 'diagnosis_categories',
    align: 'left',
  },
  {
    label: 'First Session',
    key: 'first_session_date',
    align: 'left',
  },
  {
    label: 'Completed',
    key: 'completion_date',
    align: 'left',
  },
  {
    label: 'Sessions',
    key: 'session_count',
    align: 'center',
  },
  {
    label: 'BillingType',
    key: 'billing_category',
    align: 'center',
  },
  {
    label: 'Providers',
    key: 'providers',
    align: 'left',
  },
  {
    label: '',
    key: 'actions',
    align: 'center',
  },
];

const CaseTable = props => {
  const isEmpty = !props.rows || !props.rows.length;
  return (
    <>
      <Paper 
        sx={{ width: '100%', display: {xs: 'none', sm: 'block'}}} 
        elevation={0}
      >
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{'th': {paddingBottom: '6px'}}}>
                {
                  columns
                    .filter(col => 
                      props?.columns
                      ? (props.columns || []).includes(col.key)
                      : true
                    )
                    .map((col, i) => 
                      <TableCell key={i} align={col.align}>
                        {col.label}
                      </TableCell>
                    )
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {(props.rows|| []).map(row =>
                <CaseTableRow
                  {...row}
                  columns={props?.columns}
                  // afterSave={() => {
                  //   props.afterSave();
                  // }}
                />
              )}
            </TableBody>
          </Table>
          {
            isEmpty
            ? <BlankContent
              title='No cases found'
              Icon={ViewListIcon}
            />
            : null
          }
        </TableContainer>
        {
          !isEmpty &&
          <Box sx={{marginTop: '0.625rem'}}>
            <CustomPagination
              pageSize={props.pageSize}
              pageIndex={props.pageIndex}
              count={props.count}
              onPageChange={(e,num) => props.onPageChange(e, num)}
            ></CustomPagination>
          </Box>
        }

      </Paper>
      {/* If screen size is xs then replace the table with a mobile-friendly list */}
      <Box sx={{display: {'xs': 'block', 'sm': 'none', 'md': 'none', 'lg': 'none'}}}>
        <Stack spacing={1} padding={1}>
          {(props.rows|| []).map(row =>
            <CaseCard caseData={row.data} />
          )}
        </Stack>
        <Box style={{marginTop: '1em'}}>
          { props.rows && props.rows.length
            ? <Stack direction='row' justifyContent='center'>
                <CustomPagination
                  pageSize={props.pageSize}
                  pageIndex={props.pageIndex}
                  count={props.count}
                  onPageChange={props.onPageChange}
                ></CustomPagination>
            </Stack>
            : null
          }
        </Box>
        {
          isEmpty
          ? <BlankContent
            title='No cases found'
            Icon={ViewListIcon}
          />
          : null
        }
      </Box>
    </>
  );
};

CaseTable.defaultProps = {
};

CaseTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object, // data for the row
    buttons: PropTypes.arrayOf(PropTypes.element),
  })),
  // Optional: list of column keys to include. Otherwise will show all columns.
  columns: PropTypes.arrayOf(PropTypes.string),
  count: PropTypes.number,
  pageIndex: PropTypes.number,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  afterSave: PropTypes.func,
};

export default CaseTable;
